import _classCallCheck from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/inherits";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { EventType, PlatformEvent } from "./PlatformEvent";
export var ServiceEvent = /*#__PURE__*/function (_PlatformEvent) {
  _inherits(ServiceEvent, _PlatformEvent);

  function ServiceEvent(eventName, jsonstring) {
    var _this;

    var eventType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EventType.Info;

    _classCallCheck(this, ServiceEvent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ServiceEvent).call(this, eventName, eventType));
    _this.privJsonResult = jsonstring;
    return _this;
  }

  _createClass(ServiceEvent, [{
    key: "jsonString",
    get: function get() {
      return this.privJsonResult;
    }
  }]);

  return ServiceEvent;
}(PlatformEvent); // tslint:disable-next-line:max-classes-per-file

export var ConnectionEvent = /*#__PURE__*/function (_PlatformEvent2) {
  _inherits(ConnectionEvent, _PlatformEvent2);

  function ConnectionEvent(eventName, connectionId) {
    var _this2;

    var eventType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EventType.Info;

    _classCallCheck(this, ConnectionEvent);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ConnectionEvent).call(this, eventName, eventType));
    _this2.privConnectionId = connectionId;
    return _this2;
  }

  _createClass(ConnectionEvent, [{
    key: "connectionId",
    get: function get() {
      return this.privConnectionId;
    }
  }]);

  return ConnectionEvent;
}(PlatformEvent); // tslint:disable-next-line:max-classes-per-file

export var ConnectionStartEvent = /*#__PURE__*/function (_ConnectionEvent) {
  _inherits(ConnectionStartEvent, _ConnectionEvent);

  function ConnectionStartEvent(connectionId, uri, headers) {
    var _this3;

    _classCallCheck(this, ConnectionStartEvent);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(ConnectionStartEvent).call(this, "ConnectionStartEvent", connectionId));
    _this3.privUri = uri;
    _this3.privHeaders = headers;
    return _this3;
  }

  _createClass(ConnectionStartEvent, [{
    key: "uri",
    get: function get() {
      return this.privUri;
    }
  }, {
    key: "headers",
    get: function get() {
      return this.privHeaders;
    }
  }]);

  return ConnectionStartEvent;
}(ConnectionEvent); // tslint:disable-next-line:max-classes-per-file

export var ConnectionEstablishedEvent = /*#__PURE__*/function (_ConnectionEvent2) {
  _inherits(ConnectionEstablishedEvent, _ConnectionEvent2);

  function ConnectionEstablishedEvent(connectionId, metadata) {
    _classCallCheck(this, ConnectionEstablishedEvent);

    return _possibleConstructorReturn(this, _getPrototypeOf(ConnectionEstablishedEvent).call(this, "ConnectionEstablishedEvent", connectionId));
  }

  return ConnectionEstablishedEvent;
}(ConnectionEvent); // tslint:disable-next-line:max-classes-per-file

export var ConnectionClosedEvent = /*#__PURE__*/function (_ConnectionEvent3) {
  _inherits(ConnectionClosedEvent, _ConnectionEvent3);

  function ConnectionClosedEvent(connectionId, statusCode, reason) {
    var _this4;

    _classCallCheck(this, ConnectionClosedEvent);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(ConnectionClosedEvent).call(this, "ConnectionClosedEvent", connectionId, EventType.Debug));
    _this4.privRreason = reason;
    _this4.privStatusCode = statusCode;
    return _this4;
  }

  _createClass(ConnectionClosedEvent, [{
    key: "reason",
    get: function get() {
      return this.privRreason;
    }
  }, {
    key: "statusCode",
    get: function get() {
      return this.privStatusCode;
    }
  }]);

  return ConnectionClosedEvent;
}(ConnectionEvent); // tslint:disable-next-line:max-classes-per-file

export var ConnectionEstablishErrorEvent = /*#__PURE__*/function (_ConnectionEvent4) {
  _inherits(ConnectionEstablishErrorEvent, _ConnectionEvent4);

  function ConnectionEstablishErrorEvent(connectionId, statuscode, reason) {
    var _this5;

    _classCallCheck(this, ConnectionEstablishErrorEvent);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(ConnectionEstablishErrorEvent).call(this, "ConnectionEstablishErrorEvent", connectionId, EventType.Error));
    _this5.privStatusCode = statuscode;
    _this5.privReason = reason;
    return _this5;
  }

  _createClass(ConnectionEstablishErrorEvent, [{
    key: "reason",
    get: function get() {
      return this.privReason;
    }
  }, {
    key: "statusCode",
    get: function get() {
      return this.privStatusCode;
    }
  }]);

  return ConnectionEstablishErrorEvent;
}(ConnectionEvent); // tslint:disable-next-line:max-classes-per-file

export var ConnectionMessageReceivedEvent = /*#__PURE__*/function (_ConnectionEvent5) {
  _inherits(ConnectionMessageReceivedEvent, _ConnectionEvent5);

  function ConnectionMessageReceivedEvent(connectionId, networkReceivedTimeISO, message) {
    var _this6;

    _classCallCheck(this, ConnectionMessageReceivedEvent);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(ConnectionMessageReceivedEvent).call(this, "ConnectionMessageReceivedEvent", connectionId));
    _this6.privNetworkReceivedTime = networkReceivedTimeISO;
    _this6.privMessage = message;
    return _this6;
  }

  _createClass(ConnectionMessageReceivedEvent, [{
    key: "networkReceivedTime",
    get: function get() {
      return this.privNetworkReceivedTime;
    }
  }, {
    key: "message",
    get: function get() {
      return this.privMessage;
    }
  }]);

  return ConnectionMessageReceivedEvent;
}(ConnectionEvent); // tslint:disable-next-line:max-classes-per-file

export var ConnectionMessageSentEvent = /*#__PURE__*/function (_ConnectionEvent6) {
  _inherits(ConnectionMessageSentEvent, _ConnectionEvent6);

  function ConnectionMessageSentEvent(connectionId, networkSentTimeISO, message) {
    var _this7;

    _classCallCheck(this, ConnectionMessageSentEvent);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(ConnectionMessageSentEvent).call(this, "ConnectionMessageSentEvent", connectionId));
    _this7.privNetworkSentTime = networkSentTimeISO;
    _this7.privMessage = message;
    return _this7;
  }

  _createClass(ConnectionMessageSentEvent, [{
    key: "networkSentTime",
    get: function get() {
      return this.privNetworkSentTime;
    }
  }, {
    key: "message",
    get: function get() {
      return this.privMessage;
    }
  }]);

  return ConnectionMessageSentEvent;
}(ConnectionEvent);